var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffe(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.06579 0.75V1.69737M5.96053 0.75V1.69737M6.90789 3.59211C7.03352 3.59211 7.15401 3.64201 7.24284 3.73084C7.33167 3.81968 7.38158 3.94016 7.38158 4.06579V7.85526C7.38158 8.35778 7.18196 8.83971 6.82662 9.19504C6.47129 9.55038 5.98936 9.75 5.48684 9.75H2.64474C2.14222 9.75 1.66029 9.55038 1.30496 9.19504C0.949623 8.83971 0.75 8.35778 0.75 7.85526V4.06579C0.75 3.94016 0.799906 3.81968 0.888739 3.73084C0.977572 3.64201 1.09806 3.59211 1.22368 3.59211H7.85526C8.35778 3.59211 8.83971 3.79173 9.19504 4.14706C9.55038 4.50239 9.75 4.98433 9.75 5.48684C9.75 5.98936 9.55038 6.47129 9.19504 6.82662C8.83971 7.18196 8.35778 7.38158 7.85526 7.38158H7.38158M2.17105 0.75V1.69737",
    stroke: "#6D3606",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffe);
export default __webpack_public_path__ + "static/media/coffe.84fb19ac040427d4e43ba6a72fba5888.svg";
export { ForwardRef as ReactComponent };